"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePaymentSchema = exports.BaseSheetContext = void 0;
const zod_1 = require("zod");
const string_fns_1 = require("./utils/string.fns");
const DefaultPaymentType = 13;
exports.BaseSheetContext = zod_1.z.object({
    data: zod_1.z
        .object({
        payment_type: zod_1.z.number().optional(),
    })
        .optional()
        .default({ payment_type: DefaultPaymentType }),
});
exports.BasePaymentSchema = zod_1.z.object({
    creditor_name: zod_1.z.string().min(1),
    amount: zod_1.z.number().min(0.01),
    cpf_or_cnpj: string_fns_1.cpfCnpjValidator.transform(Number),
    transfer: zod_1.z.object({
        type: zod_1.z.literal('account'),
        branch: zod_1.z.coerce.number().min(1, 'O número da agência é inválido'),
        account: zod_1.z.coerce.number().min(1, 'O número da conta é inválido'),
        account_digit: zod_1.z.coerce.number().min(0, 'O dígito da conta é inválido').optional().default(0),
    }),
    payroll_checkout_id: zod_1.z.number().optional(),
});
